import React from 'react'

const Home = () => {
  return (
    <>
    <div>
    <h2 style={{ textAlign:"center",textDecoration:"underline"}}>Welcome to your mail box</h2>
    </div>
    </>
  )
}

export default Home